var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 0C8.50659 0 0 8.50659 0 19C0 29.4934 8.50659 38 19 38C29.4934 38 38 29.4934 38 19C38 8.50659 29.4934 0 19 0ZM28.1251 13.12C28.7324 13.7484 28.9307 15.1755 28.9307 15.1755C28.9307 15.1755 29.1333 16.8518 29.1333 18.5274V20.0988C29.1333 21.7751 28.9307 23.4507 28.9307 23.4507C28.9307 23.4507 28.7324 24.8778 28.1251 25.5062C27.4307 26.2496 26.6607 26.3265 26.2255 26.3699C26.1776 26.3747 26.1338 26.379 26.0946 26.3838C23.2585 26.5935 19 26.6 19 26.6C19 26.6 13.7307 26.5508 12.1093 26.3916C12.0325 26.3769 11.9394 26.3655 11.8339 26.3526C11.3204 26.2896 10.5143 26.1908 9.8743 25.5062C9.26693 24.8778 9.06933 23.4507 9.06933 23.4507C9.06933 23.4507 8.86667 21.7751 8.86667 20.0988V18.5274C8.86667 16.8518 9.06933 15.1755 9.06933 15.1755C9.06933 15.1755 9.26693 13.7484 9.8743 13.12C10.5702 12.3755 11.3409 12.2995 11.7762 12.2566C11.8234 12.252 11.8666 12.2477 11.9054 12.243C14.7415 12.0333 18.9956 12.0333 18.9956 12.0333H19.0044C19.0044 12.0333 23.2585 12.0333 26.0946 12.243C26.1334 12.2477 26.1766 12.252 26.2239 12.2567C26.6588 12.2996 27.4298 12.3756 28.1251 13.12Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9077 22.0029L16.907 16.1838L22.3828 19.1034L16.9077 22.0029Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.96af1a8d6bbea0f64dcfce1881e0bf6f.svg";
export { ForwardRef as ReactComponent };